import * as type from './types';

export function loginOtpS(data) {
    return {
        type: type.POST_OTP_LOGIN_CONFIRM_REQUESTED,
        data: data,
    }
}

export function clearLoginOtpSecondStepError() {
    return {
        type: type.CLEAR_LOGIN_OTP_SECOND_STEP_ERROR,
    }
}